import ProcessFlowStepValidation from '~/models/navigableValidations/processFlowStepValidation'
import ProcessFlowTakeActionStepReferenceValidator from '~/models/navigableValidators/processFlowTakeActionStepReferenceValidator'
import {ValidationModalSection} from '~/models/navigableValidations/validationSections'
import {ProcessFlowTakeActionStep} from '~/models/processFlows/steps/processFlowTakeActionStep'

export default class ProcessFlowTakeActionStepValidation extends ProcessFlowStepValidation<ProcessFlowTakeActionStep> {
  validators = new ProcessFlowStepValidation(this.model).validators.concat([
    new ProcessFlowTakeActionStepReferenceValidator({
      section: ValidationModalSection.ProcessFlowStep
    })
  ]);
}